<template>
  <div class="flexChart">
    <div class="chartContent">
      <div class="content"><span class="color">Monatsmittel</span> seit Beginn 2025 in °C**</div>
      <div class="content content_sans color2">Langzeitmittel 1991–2020</div>
    </div>
    <div class="chartContainer" ref="chartContainer">
      <div ref="chart" class="lineChart"></div>
    </div>
  </div>
</template>

<script>
import { store } from "../store";
import * as d3 from "d3";
import { timeParse } from "d3";

import _ from "lodash";

export default {
  data() {
    return {
      store,
    };
  },
  props: {
    dataTempMonth: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleResize: _.debounce(function () {
      this.windowWidth = window.innerWidth;
      const chartParent = this.$refs.chart;
      const svgNode = chartParent.querySelector("svg");
      chartParent.removeChild(svgNode);
      this.drawChart(this.$refs.chartContainer.clientWidth);
    }, 200),
    drawChart(containerWidth) {
      const chartWidth = containerWidth;
      //console.log("drawChart dataTempMonth", console.log(JSON.stringify(this.dataTempMonth)));

      let newArray = [];
      for (let i = 0; i < this.dataTempMonth.length; i++) {
        let subArray = this.dataTempMonth[i];
        let newSubArray = [];
        for (let j = 0; j < subArray.length; j++) {
          let item = subArray[j];
          let newItem = [(j + 1).toString().padStart(2, "0"), ...item];
          newSubArray.push(newItem);
        }
        newArray.push(newSubArray);
      }

      // Define the format string for parsing dates
      const formatString = "%Y-%m-%d";

      // Create a parser function using the format string
      const parseDate = timeParse(formatString);

      // Parse the data
      const parsedData = newArray.map((yearData) => {
        return yearData.map((monthData) => {
          // Add the month and year information to the date string
          const dateString = `20${yearData === newArray[0] ? "23" : "23"}-${monthData[0]}-01`;
          const date = parseDate(dateString);
          return [date, ...monthData.slice(1)];
        });
      });

      const dataMonth = parsedData[1];
      const dataNow = parsedData[0];

      const data = dataMonth.map((d) => ({
        date: d[0],
        dateText: d[1],
        value: d[2],
        minValue: d[3],
        maxValue: d[4],
      }));
      const data2 = dataNow.map((d) => ({
        date: d[0],
        dateText: d[1],
        value: d[2],
        minValue: d[3],
        maxValue: d[4],
      }));

      const margin = { top: 0, right: 8, bottom: 16, left: 10 };
      const width = chartWidth - margin.left - margin.right;
      const height = 96 - margin.top - margin.bottom;

      // Set the width of the left axis
      const yAxisWidth = 10;
      const xAxisHeight = 16;

      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

      // axis
      const x = d3
        .scaleTime()
        .domain(d3.extent(data, (d) => d.date))
        .range([0, width - yAxisWidth]);
      const xAxis = d3.axisBottom(x);
      xAxis.tickSize(0).tickSizeInner(0);

      const y = d3
        .scaleLinear()
        .domain([0, d3.max([d3.max(data, (d) => d.value), d3.max(data2, (d) => d.value) + 3])])
        .range([height, 0])
        .nice();

      const tickValues = y.ticks(5).filter((d) => d !== y.domain()[1]);
      const lastValue = tickValues[tickValues.length - 1]; // Letzter Wert aus den Daten
      const yAxis = d3
        .axisLeft(y)
        .ticks(5)
        .tickPadding(4)
        .tickSize(0)
        .tickSizeInner(-width)
        .tickFormat((d) => (d >= lastValue ? "" : d)); // add " Grad" to tick value 5#

      svg
        .append("g")
        .call(yAxis)
        .classed("axis-label", true)
        .attr("transform", "translate(" + yAxisWidth + ", 0)")
        .select(".tick:last-of-type line")
        .style("stroke", "transparent");

      svg
        .append("g")
        .attr("transform", `translate(${margin.left + 5}, ${height + 2})`)
        .attr("width", `translate(100% - ${yAxisWidth})`)
        .call(xAxis)
        .classed("axis-label", true)
        .attr("opacity", 0);

      svg
        .append("g")
        .attr("transform", `translate(${margin.left}, ${height + 2})`)
        .attr("width", `${width})`)
        .classed("axis-label", true);
      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", 15)
        .attr("y", height + margin.bottom - 4)
        .attr("text-anchor", "start")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[0].dateText);

      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", width / 2)
        .attr("y", height + margin.bottom - 4)
        .style("text-anchor", "middle")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[5].dateText);

      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", width)
        .attr("y", height + margin.bottom - 4)
        .attr("text-anchor", "end")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[data.length - 1].dateText);

      // first linie
      const line = d3
        .line()
        .x((d) => x(d.date))
        .y((d) => y(d.value));

      svg
        .append("path")
        .datum(data)
        .attr("fill", "none")
        .attr("stroke", "var(--mm-red-color2)")
        .attr("stroke-width", 2)
        .attr("d", line)
        .attr("transform", "translate(" + (yAxisWidth + yAxisWidth / 2) + ", 0)");

      //second linie
      const line2 = svg.append("g").attr("class", "line2").datum(data2);
      line2
        .append("path")
        .attr("fill", "none")
        .attr("stroke", "var(--mm-red-color)")
        .attr("transform", "translate(" + (yAxisWidth + yAxisWidth / 2) + ", 0)")
        .attr("stroke-width", 2)
        .attr("d", line);

      // Add tooltip to chart
      const tooltip = d3.select(this.$refs.chart).append("div").attr("class", "tooltip").style("opacity", 0);

      // Add vertical line on mouseover
      const verticalLine = svg
        .append("line")
        .attr("class", "vertical-line")
        .attr("y1", 0)
        .attr("y2", height)
        .attr("stroke", "#ddd")
        .attr("stroke-width", 1)
        .attr("opacity", 0);

      // Add horizontal line on mouseover
      const horizontalLine = svg
        .append("line")
        .attr("class", "horizontal-line")
        .attr("x1", 0)
        .attr("x2", width)
        .attr("stroke", "grey")
        .attr("stroke-width", 1)
        .attr("opacity", 0);

      const mask = svg
        .append("rect")
        .attr("width", width + margin.left + 0)
        .attr("height", height + margin.top + margin.bottom)
        .attr("transform", "translate(" + (yAxisWidth + yAxisWidth / 2) + ", 0)")
        .style("fill", "transparent")
        .attr("class", "mask")
        .style("cursor", "pointer")
        .on("mouseover", () => {})
        .on("mouseout", () => {
          tooltip.style("opacity", 0);
          verticalLine.attr("opacity", 0);
          circleLine1.attr("opacity", 0);
          circleLine2.attr("opacity", 0);
        })
        .on("touchmove mousemove", mouseMove);

      var circleLine1 = svg
        .append("circle")
        .attr("class", "circle")
        .attr("r", 3)
        .attr("fill", "#E7889D")
        .attr("stroke", "#E2E2E2")
        .attr("stroke-width", 1)
        .attr("opacity", 0);

      var circleLine2 = svg
        .append("circle")
        .attr("class", "circle")
        .attr("r", 3)
        .attr("fill", "#B31938")
        .attr("stroke", "#E2E2E2")
        .attr("stroke-width", 1)
        .attr("opacity", 0);

      // Add mouseover event handler to chart
      function mouseMove(event) {
        // Get mouse coordinates and invert them to get chart coordinates
        const [xCoord, yCoord] = d3.pointer(event);
        const x0 = x.invert(xCoord);
        const y0 = y.invert(yCoord);

        // Get nearest data point to mouse coordinates
        const containerOffset = svg.node().getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const bisectLine1 = d3.bisector((d) => d.date).left;
        const iLine1 = bisectLine1(data, x0, 1);
        const dLine1_0 = data[iLine1 - 1];
        const dLine1_1 = data[iLine1];
        const d = x0 - dLine1_0.date >= dLine1_1.date - x0 ? dLine1_1 : dLine1_0;

        const bisectLine2 = d3.bisector((d2) => d2.date).left;
        const iLine2 = bisectLine2(data2, x0, 1);
        const dLine2_0 = data2[iLine2 - 1];
        const dLine2_1 = data2[iLine2];

        var d2;
        if (typeof dLine2_1 !== "undefined") {
          d2 = x0 - dLine2_0.date >= dLine2_1.date - x0 ? dLine2_1 : dLine2_0;
        } else if (typeof d02 !== undefined && String(dLine2_0.date) != String(dLine1_0.date)) {
          d2 = undefined;
        } else {
          d2 = x0 - dLine1_0.date >= dLine1_1.date - x0 ? undefined : dLine2_0;
        }
        // Update tooltip and lines
        tooltip
          .style("opacity", 1)
          .html(
            `<div class="tooltipFlex"><span class="stierli">${d.dateText}</span><span class="d1 ${
              d2 != undefined && d.value >= d2.value ? " order" : ""
            }"><b>${
              d.value != null
                ? typeof d.value === "string"
                  ? d.value.replace(".", ",")
                  : String(d.value).replace(".", ",")
                : ""
            }\u2009°C</b></span>
            ${
              typeof d2 !== "undefined" && String(dLine2_0.date) == String(dLine1_0.date)
                ? typeof d2.value === "string"
                  ? '<span class="d2"><b>' + d2.value.replace(".", ",") + "\u2009°C</b><span>"
                  : '<span class="d2"><b>' + String(d2.value).replace(".", ",") + "\u2009°C</b><span>"
                : ""
            }</div>`
          )
          .style("left", event.pageX - containerOffset.left + "px")
          .style("top", height / 2 + "px")
          .style("cursor", "pointer");

        verticalLine
          .attr("x1", x(d.date) + (yAxisWidth + yAxisWidth / 2) - 0.25)
          .attr("x2", x(d.date) + (yAxisWidth + yAxisWidth / 2) - 0.25)
          .attr("class", "verticalLine")
          .style("pointer-events", "none")
          .attr("opacity", 1);

        circleLine1
          .attr("cx", x(d.date) + (yAxisWidth + yAxisWidth / 2) - 0.25)
          .attr("cy", y(d.value))
          .style("pointer-events", "none")
          .attr("opacity", 1);

        if (d2 !== undefined) {
          circleLine2
            .attr("cx", x(d2.date) + (yAxisWidth + yAxisWidth / 2) - 0.25)
            .attr("cy", y(d2.value))
            .style("pointer-events", "none")
            .attr("opacity", 1);
        } else {
          circleLine2.attr("opacity", 0);
        }

        // horizontalLine.attr("y1", y(d.value)).attr("y2", y(d.value)).attr("class", "horizontalLine").attr("opacity", 1);
        // circle.attr("cx", x(d.date)).attr("cy", y(d.value)).attr("opacity", 1);
      }

      // Add circle on mouseover
      const circle = svg
        .append("circle")
        .attr("class", "circle")
        .attr("r", 5)
        .attr("fill", "steelblue")
        .attr("opacity", 0);

      line2
        .selectAll(".dot")
        .data(data2.filter((d, i) => i === data2.length - 1))
        .join("circle")
        .attr("class", "dot")
        .attr("transform", "translate(" + (yAxisWidth + yAxisWidth / 2) + ", 0)")
        .attr("fill", "var(--mm-red-color)")
        .attr("cx", (d) => x(d.date))
        .attr("cy", (d) => y(d.value))
        .attr("r", 4);
    },
  },
  watch: {
    dataTempMonth() {
      let chartWidth = this.$refs.chartContainer.clientWidth;
      this.drawChart(chartWidth);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.lineChart svg {
  width: 100%;
  height: auto;
}
</style>
